// extracted by mini-css-extract-plugin
export var title = "styles-module--title--ba4fd";
export var white = "styles-module--white--d39c4";